<template>
    <v-container id="client_profile" grid-list-md fluid>
      <v-row justify="center" no-gutters>
        <v-col lg=6>
        <client-form/>
      </v-col>
      </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import cForm from "./ClientForm.vue";

export default {

  components: {
    "client-form": cForm,
  },

  data() {
    return {
      client: {},
    }
  },

  mounted() {
    this.loadClient();
  },
  methods: {
    loadClient() {
      axios
        .get("/client_routes/client")
        .then((response) => {
          this.client = response.data[0];
        })
        .catch((e) => {
          console.log("Error loading client " + e)
        });
    },
  },

  computed: {
    DepotName() {
        return !this.$store.getters.user
          ? false
          : this.$store.getters.user.DepotName;
      },
  }
};
</script>

<style></style>
